export default __webpack_public_path__ + "static/media/deathlord.2fd06fc7.png";